import { render, staticRenderFns } from "./CoreValuesList.vue?vue&type=template&id=f9bdc6b4&scoped=true&"
import script from "./CoreValuesList.vue?vue&type=script&lang=js&"
export * from "./CoreValuesList.vue?vue&type=script&lang=js&"
import style0 from "./CoreValuesList.vue?vue&type=style&index=0&id=f9bdc6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bdc6b4",
  null
  
)

export default component.exports